export default __webpack_public_path__ + "static/poster-dd660d6c7a17b7755815d7df656ee481.png";